import confirmationContent from "./confirmation-content/confirmation-content.vue";

export default {
  components: {
    confirmationContent,
  },
};
